import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { MdEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { updateLocation } from "../../../redux/locations/locationSlice";
import Loading from "../../../Components/Common/Loading";
import Swal from "sweetalert2";

const LocationsTd = ({ toggleCreateProviderForm, currentPage, setCurrentPage }) => {
  const { locations, fetchStatus } = useSelector(
    (state) => state.locations
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formatDate = (date) => {
    const d = new Date(date);
    return d.toLocaleString('en-US', {month: 'short',day: '2-digit',year: 'numeric',hour: '2-digit',minute: '2-digit',});
  };

  const handleToggle = async (location, event) => {
    event.stopPropagation();
    
    const result = await Swal.fire({
      title: "Are you sure?",
      text: `Do you want to change the status to ${location.status ? "Pending" : "Active"}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#1769d1",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change it!"
    });
    if (result.isConfirmed) {
      try {
        const newLocation = {status: !location.status};
        // eslint-disable-next-line
        const result = await dispatch(updateLocation({ 
          id: location._id, 
          newLocation 
        })).unwrap();
        const updatedLocations = locations.map(loc => 
          loc._id === location._id 
            ? { ...loc, status: !location.status }
            : loc
        );
        dispatch({ type: 'locations/refreshlocations', payload: updatedLocations });
        Swal.fire({
          title: "Updated!",
          text: "Location status has been updated successfully.",
          icon: "success",
          confirmButtonColor: "#1769d1"
        });

      } catch (error) {        
        Swal.fire({
          title: "Error!",
          text: error || "Could not update status. Please try again.",
          icon: "error",
          confirmButtonColor: "#1769d1"
        });
      }
    }
  };

  const handleEditClick = (id, event) => {
    event.stopPropagation();
    navigate(`/providers/locations?id=${id}`);
    toggleCreateProviderForm();
  };

  return (
    <>
      {fetchStatus === "loading" && (
        <div className="absolute inset-0 flex justify-center items-center bg-white bg-opacity-50 z-50">
          <Loading size="16" color="brand-500" />
        </div>
      )}

      {locations?.length > 0 &&
        locations.map((item) => (
          <tr
            key={item._id}
            className="hover:bg-gray-100 bg-gray-50 border border-gray-300 hover:shadow-lg transition duration-300 ease-in-out cursor-pointer"
          >
            <td className="py-4 px-6 font-medium">{item?.displayName || item?.name}</td>
            <td className="py-4 px-6">
              {item?.address?.addressLine1 || "No Address Available"}
              <div className="text-xs text-gray-600">
                {item?.address?.city && item?.address?.state
                  ? `${item?.address?.city}, ${item?.address?.state}`
                  : "Location information not available"}
              </div>
            </td>
            <td className="py-4 px-6">
              <span
                className={`inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold ${
                  item.status === false
                    ? "bg-blue-100 text-blue-900"
                    : "bg-green-100 text-green-900"
                }`}
              >
                {item.status ? "Active" : "Pending"}
              </span>
            </td>
            <td className="py-4 px-6 text-[13px]">{formatDate(item?.createdAt)}</td>
            <td className="py-4 px-6 text-[13px]">{formatDate(item?.updatedAt)}</td>
           
            <td className="flex flex-flow-col gap-6 text-xl   text-brand-500 py-5 px-7 text-[13px]">
              <div
                className="hover:bg-gray-300 rounded-full p-2"
                onClick={(event) => handleEditClick(item._id, event)}
              >
                <MdEdit />
              </div>
            </td>
            <td className="py-4 px-6 text-[13px]">
            <label
              htmlFor={`toggle-${item._id}`}
              className="flex items-center gap-2 w-full max-w-full cursor-pointer"
            >
              <input
                type="checkbox"
                id={`toggle-${item._id}`}
                checked={item.status}
                onChange={(event) => handleToggle(item, event)}
                className="sr-only"
              />
              <div
                className={`w-10 h-6 flex items-center rounded-full p-1 transition duration-300 ease-in-out ${
                  item.status ? "bg-brand-500" : "bg-gray-300"
                }`}
              >
                <div
                  className={`w-4 h-4 bg-white rounded-full shadow-md transform transition duration-300 ease-in-out ${
                    item.status ? "translate-x-4" : "translate-x-0"
                  }`}
                ></div>
              </div>
            </label>
          </td>
          </tr>
        ))}
    </>
  );
};

export default LocationsTd;